import * as types from './mutationTypes'
import api from '../api/index'
import { MessageBox, Notification } from 'element-ui'
import Bus from '../bus'
import {
  setShoppingCar,
  clearShoppingCar,
  setUserInfoAsync,
  clearUserInfoAsync,
  setSearchText,
  clearSearchText
} from 'common/js/store'

export const addProductToCar = ({
  commit,
  state
}, product) => {
  const event = product.target
  delete product.target
  api.singlesavecart(product).then(res => {
    if (res.status === 0) {
      const count = state.shoCartCount + 1
      commit(types.SHOP_CAR_COUNT, count) // 更新购物车数量
      Bus.$emit('ballDrop', event)
    } else if (res.status === 1) {
      Notification.error({
        title: '错误',
        duration: 2500,
        message: '不能重复购买'
      })
    } else if (res.status === 2) {
      Notification.error({
        title: '错误',
        duration: 2500,
        message: '该产品已经在购物车'
      })
    } else {
      Notification.error({
        title: '错误',
        duration: 2500,
        message: '网络错误，加入购物车失败请重试'
      })
    }
  }).catch(res => {})
}

export const setUserInfo = ({
  commit,
  state
}, userInfo) => {
  commit(types.SET_USER_INFO, setUserInfoAsync(userInfo))
}

export const clearUserInfo = ({
  commit,
  state
}) => {
  clearUserInfoAsync()
  commit(types.SET_USER_INFO, {})
}

export const clearShopping = ({
  commit,
  state
}) => {
  clearShoppingCar()
  commit(types.SET_SHOP_CAR, [])
}

export const isSendCode = ({
  commit,
  state
}, blooer) => {
  commit(types.IS_SEND_CODE, blooer)
}

export const setSearch = ({
  commit,
  state
}, searchText) => {
  commit(types.SEARCH_TEXT, setSearchText(searchText))
}

export const clearSearch = ({
  commit,
  state
}) => {
  clearSearchText()
  commit(types.SEARCH_TEXT, '')
}

export const updateShopCar = ({commit, state}, car) => {
  commit(types.SET_SHOP_CAR, setShoppingCar(car))
}

export const upDateShopCarCount = ({commit, state}) => {
  const count = state.shoCartCount + 1
  commit(types.SHOP_CAR_COUNT, count)
}

export const updateLogin = ({commit, state}, login) => {
  commit(types.SHOW_LOGIN, login)
}



// WEBPACK FOOTER //
// ./src/store/actions.js